<template>
  <div class="gallery ld-background ld-right-slide ld-scroll-y">
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div class="text-xs-center">
      <img class="image" :src="image" v-on:click="selectForIndex(imageIndex)" v-for="(image, imageIndex) in images" :key="imageIndex">
    </div>
  </div>
</template>

<script>
  import GeneralMixin from '../mixins/general_mixin';
  import _VueGallery from 'vue-gallery';

  export default {
    components: {
      'gallery': _VueGallery
    },

    methods: {
      selectForIndex(index) {
        this.index = index;
      }
    },

    mixins: [GeneralMixin],

    name: 'galleryComponent',

    props: ['screenWidthSmall'],

    data() {
      return {
        index: null,
        images: [
          this.getGalleryImagePath('lollicup_gallery_01_1200w.jpg'),
          this.getGalleryImagePath('lollicup_gallery_03_1200w.jpg'),
          this.getGalleryImagePath('lollicup_gallery_04_1200w.jpg')
        ]
      };
    }
  };
</script>

<style scoped>
  .image {
    border: 1px solid rgba(200, 200, 200, .5);
    margin: .5rem;
    width: 100%;
    max-width: 220px;
  }
</style>



// WEBPACK FOOTER //
// src/components/gallery_component.vue